<script>
  import {
    commonData,
    selectedArea,
    selectedPart,
    procedureList,
  } from '../../../../../../../../store/common';
  import { ENV } from '../../../../../../../../core/constants/env';

  const onChangeArea = item => {
    selectedArea.set(item);
    selectedPart.set({});
    procedureList.set([]);
  };

  $: geActiveClass = item => {
    if (
      $selectedArea.id === item.id ||
      ($selectedArea.id === 'female_body_back' && item.id === 'female_body') ||
      ($selectedArea.id === 'male_body_back' && item.id === 'male_body')
    ) {
      return 'uk-button-primary';
    }
  };
</script>

<div class="uk-flex uk-margin-bottom">
  {#each $commonData as item}
    {#if !item.back}
      <a
        class="uk-icon-button uk-margin-small-right {geActiveClass(item)}"
        style="height: 48px; width: 48px"
        on:click={() => onChangeArea(item)}
      >
        <img
          class="uk-width"
          style={item.style}
          data-src={`${ENV.FRONT_URL}${item.icon}`}
          data-uk-img
          alt="Female face"
        />
      </a>
    {/if}
  {/each}
</div>
